import React from 'react';
export function StorySection() {
  return <section className="py-20 px-4 bg-white" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        {/* Section 1: The Hook */}
        <article className="mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-brown" data-id="element-160">
            Have you looked in the mirror today and struggled to recognize the
            woman looking back?
          </h2>
          <div className="prose prose-lg md:prose-xl text-brown-light font-body leading-relaxed" data-id="element-161">
            <p className="first-letter:text-5xl first-letter:font-heading first-letter:font-bold first-letter:text-sage first-letter:mr-3 first-letter:float-left" data-id="element-162">
              I'm not just talking about the dark circles or the hair thrown up
              in a rush. I'm talking about that spark of ambition, that mental
              sharpness, and that unshakable confidence you had before diapers
              and bottles became your entire world.
            </p>
            <p data-id="element-163">
              If you feel like your "old self" has disappeared somewhere between
              midnight feedings and daily chaos... I want you to know you're not
              alone. And most importantly:{' '}
              <strong data-id="element-164">it doesn't have to stay this way.</strong>
            </p>
          </div>
        </article>

        <div className="flex justify-center mb-16" data-id="element-165">
          <div className="w-16 h-1 bg-gold rounded-full" data-id="element-166"></div>
        </div>

        {/* Section 2: Agitating the Pain */}
        <article className="mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-brown" data-id="element-168">
            Nobody warned you about the "Identity Death."
          </h2>
          <div className="prose prose-lg md:prose-xl text-brown-light font-body leading-relaxed space-y-6" data-id="element-169">
            <p data-id="element-170">
              They told you motherhood would be beautiful, but they forgot to
              mention the brain fog that makes you forget your keys, simple
              words, and even who you were before this. You feel like a hollow
              shell. You're physically exhausted, emotionally drained, and
              although you love your baby with all your soul, there's a part of
              you screaming in silence to regain some autonomy.
            </p>
            <p data-id="element-171">
              You've tried searching for advice on generic blogs that tell you
              to "sleep when the baby sleeps" (as if that's possible with a
              house to clean and a mind that won't stop racing). You've seen
              Instagram influencers "bounce back" in a week with private
              trainers and night nurses, while you barely have time to drink a
              hot cup of coffee.
            </p>
            <div className="bg-cream-dark p-8 rounded-xl border-l-4 border-coral my-8 shadow-warm" data-id="element-172">
              <p className="font-heading text-xl italic text-brown m-0" data-id="element-173">
                That feeling of inadequacy is not your fault. The system is
                designed to care for the baby, but it has completely forgotten
                to care for the mother.
              </p>
            </div>
          </div>
        </article>

        <div className="flex justify-center mb-16" data-id="element-174">
          <div className="w-16 h-1 bg-gold rounded-full" data-id="element-175"></div>
        </div>

        {/* Section 3: The Revelation */}
        <article data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-brown" data-id="element-177">
            The biological reason you feel this way...
          </h2>
          <div className="prose prose-lg md:prose-xl text-brown-light font-body leading-relaxed space-y-6" data-id="element-178">
            <p data-id="element-179">
              The reason you feel this way isn't a lack of willpower or love.
              It's a biological and neurological disconnection. Your postpartum
              brain is literally undergoing a remodeling process, and without
              the right protocol for nutrition, supplementation, and identity
              micro-habits, you will stay in "survival mode" for years.
            </p>
            <p data-id="element-180">
              I discovered that you don't need hours at the gym or impossible
              self-care retreats. What you need are{' '}
              <strong data-id="element-181">Strategic Micro-Actions</strong>. Small 5-minute shifts in
              your biology and mindset that hand the reins back to your
              executive system.
            </p>
            <p className="text-2xl font-heading text-sage font-bold text-center mt-10" data-id="element-182">
              That's how the Woman 90 Protocol was born: the first reintegration
              system designed for the real life of a real mother.
            </p>
          </div>
        </article>
      </div>
    </section>;
}